import type { ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="glass-panel rounded-2xl p-16 text-center">
      {icon && <div className="mb-6 inline-block heartbeat" style={{ color: '#10B981' }}>{icon}</div>}
      <h3 className="display text-3xl mb-3">{title}</h3>
      <p className="text-base mb-8 max-w-md mx-auto" style={{ color: 'rgba(240,253,244,0.6)' }}>{description}</p>
      {action}
    </div>
  );
}
